export const searchKeys = {
	naver: (text: string) => ['mantang', 'naverSearch', text] as const,
	location: (text: string, ...args: unknown[]) =>
		['mantang', 'locationSearch', text, ...args] as const,
};
